import styled from 'styled-components';
import { List } from '@alefeducation/ui-elements-library-core';
import { borderStyle } from '../../styles/Common';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-right: 25px;
`;

export const StyledTabContainer = styled(List)`
  display: flex;
  flex-direction: column;
`;

export const StyledTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${({ theme: { space } }: any) => `${space[24]}px`};
`;

export const StyledTableBody = styled.div`
  height: 80vh;

  > div:first-child {
    height: 100%;

    > div {
      height: calc(100% - 33px);
    }
  }

  ol#tablist {
    height: auto;
    margin: 0;
    padding-left: 24px;
    ${(props) => `border-bottom: ${borderStyle(props)}`}
  }
`;
